import type { GeomTypeUtil } from "./geomTypeUtil";
import type BoundsUtil from "../../boundsUtil";
import type MatrixUtil from "../../matrixUtil";
import type GeomUtil from "../geomUtil";

export default class LR implements GeomTypeUtil {
    private readonly boundsUtil: BoundsUtil;
    private readonly geomUtil: GeomUtil;
    private readonly matrixUtil: MatrixUtil;

    constructor(boundsUtil: BoundsUtil, geomUtil: GeomUtil, matrixUtil: MatrixUtil) {
        this.boundsUtil = boundsUtil;
        this.geomUtil = geomUtil;
        this.matrixUtil = matrixUtil;
    }

    /**
     * 
     * @param geom 
     * @param callback 
     * @param owner 
     */
    extractPoints(geom: any[], callback: Function, owner?: any) {
        for (let g = geom.length - 2; g >= 3; g -= 2) {
            callback.call(owner, geom, g);
        }
    }
    
    /**
     * 
     * @param geom 
     * @param callback 
     * @param owner 
     */
    extractLines(geom: any[], callback: Function, owner?: any) {
        callback.call(owner, geom, 1, geom.length);
    }
    
    /**
     * 
     * @param geom 
     * @param bounds 
     * 
     * @returns 
     */
    getBounds(geom: any[], bounds: number[]): number[] {
        return this.boundsUtil.valueOf(geom, bounds, 1);
    }
    
    /**
     * 
     * @param geom 
     * @param matrix 
     * 
     * @returns 
     */
    transform(geom: any[], matrix: number[]): any[] {
        return this.matrixUtil.transform(matrix, geom, 1, geom.length, ["LR"]);
    }
    
    /**
     * 
     * @param geom 
     * @param threshold 
     * 
     * @returns 
     */
    generalize(geom: any[], threshold: number): any[] {
        return this.geomUtil.generalizeLines(geom, 1, geom.length, threshold, ["LR"]);
    }
}
